// extracted by mini-css-extract-plugin
module.exports = {"common":"bip_common__Vminj","next":"bip_next__jclL4"};